// 加载js
interface IJsInfo {
  src: string; // js src
  isAsync?: boolean; // 是否async加载
  isDefer?: boolean; // 是否defer加载
  customAttr?: Object; // 加载js script的自定义属性
}
export function loadJS(jsInfo: IJsInfo, callback, errcallback) {
  const documentHeader = document.head || document.getElementsByTagName('head')[0];
  const scripts = document.getElementsByTagName('script');
  // 防止单页应用加载多次
  let addSign = true;
  const { src, isAsync, isDefer, customAttr } = jsInfo;
  for (let i = 0; i < scripts.length; i++) {
    if (scripts[i] && scripts[i].src && scripts[i].src.indexOf(src) !== -1) {
      addSign = false;
    }
  }
  // 已添加过
  if (!addSign) {
    callback && callback();
    return;
  }
  // 未添加过
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.charset = 'utf-8';
  if (isAsync) {
    script.async = true;
  }
  if (isDefer) {
    script.defer = true;
  }
  if (customAttr) {
    Object.keys(customAttr).forEach((item) => {
      script.setAttribute(item, customAttr[item]);
    });
  }
  script.src = src;
  documentHeader.appendChild(script);
  // eslint-disable-next-line func-names
  script.onload = function () {
    callback && callback();
  };
  // eslint-disable-next-line func-names
  script.onerror = function () {
    errcallback && errcallback();
    documentHeader.removeChild(script);
  };
}

// 跳转前滚动到顶部，解决跳转后页面没有从顶部开始的问题
export function scrollToTop() {
  // 滚动到顶部
  if (document?.documentElement || document?.body) {
    // eslint-disable-next-line no-multi-assign
    document.documentElement.scrollTop = document.body.scrollTop = 0; // 切换路由时手动置顶
  }
}
